<!--begin::Modal - Forgot Password-->
<div class="modal fade" id="kt_modal_forgot_password" tabindex="-1" aria-hidden="true">
	<!--begin::Modal dialog-->
	<div class="modal-dialog modal-dialog-centered mw-700px">
		<!--begin::Modal content-->
		<div class="modal-content">
			<!--begin::Modal body-->
			<div class="modal-body py-lg-10 px-lg-10">
				<!--begin::Close-->
				<div class="btn btn-sm btn-icon btn-color-dark modal-close" data-bs-dismiss="modal">
					<i class="ki ki-close icon-xs"></i>
				</div>
				<!--end::Close-->
				<!--begin::Authentication - Password reset -->
				<div class="d-flex flex-column flex-lg-row-fluid justify-content-center">
					<!--begin::Form-->
					<div class="d-flex flex-center flex-column flex-lg-row-fluid">
						<!--begin::Wrapper-->
						<div class="w-lg-500px p-10">
							<!--begin::Form-->
							<form class="form w-100" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" novalidate="novalidate" id="kt_password_reset_form">
								<!--begin::Heading-->
								<div class="text-center mb-10">
									<!--begin::Title-->
									<h1 class="text-gray-900 fw-bolder mb-3">Forgot Password ?</h1>
									<!--end::Title-->
									<!--begin::Link-->
									<div class="text-gray-500 fw-semibold fs-6">Enter your email to reset your password.</div>
									<!--end::Link-->
								</div>
								<!--begin::Heading-->
								<!--begin::Input group=-->
								<div class="fv-row mb-8">
									<!--begin::Email-->
									<input
										type="email"
										placeholder="Email"
										formControlName="email"
										autocomplete="off"
										class="form-control bg-transparent"
										[class.is-invalid]="forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched" />
									<!--end::Email-->
									<!--begin::Error message-->
									<div *ngIf="forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched" class="fv-plugins-message-container">
										<div class="fv-help-block">
											<span *ngIf="forgotPasswordForm.get('email')?.errors?.['required']">Email is required</span>
											<span *ngIf="forgotPasswordForm.get('email')?.errors?.['email']">Please enter a valid email address</span>
										</div>
									</div>
									<!--end::Error message-->
								</div>
								<!--begin::Actions-->
								<div class="d-flex flex-wrap justify-content-center pb-lg-0">
									<button
										type="submit"
										id="kt_password_reset_submit"
										class="btn btn-primary me-4"
										[disabled]="isLoading">
										<!--begin::Indicator label-->
										<span class="indicator-label" *ngIf="!isLoading">Submit</span>
										<!--end::Indicator label-->
										<!--begin::Indicator progress-->
										<span class="indicator-progress" *ngIf="isLoading">Please wait...
											<span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
										<!--end::Indicator progress-->
									</button>
								</div>
								<!--end::Actions-->
							</form>
							<!--end::Form-->
						</div>
						<!--end::Wrapper-->
					</div>
					<!--end::Form-->
				</div>
				<!--end::Authentication - Password reset-->
			</div>
			<!--end::Modal body-->
		</div>
		<!--end::Modal content-->
	</div>
	<!--end::Modal dialog-->
</div>
<!--end::Modal - Forgot Password-->
